module.exports = __webpack_public_path__ + "static/media/starwhite.2ed21774.svg";